import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const candidateAPI = createApi({
    reducerPath: 'candidateAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        addCandidate: builder.mutation({
            query: (details) => ({
                url: '/Candidate/AddCandidate',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteCandidate: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/DeleteCandidate/?id=${details}`),
                method: 'DELETE',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getCandidateDetailsById: builder.query({
            query: (candidateId) => ({
                url: encryptQueryString(`/Candidate/getCandidateDetailsById/?id=${candidateId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getProcessStatus: builder.query({
            query: () => ({
                url: encryptQueryString(`/Candidate/GetProcessStatus`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUserDetails: builder.query({
            query: () => ({
                url: encryptQueryString(`/Candidate/GetUserDetails`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCandidatePersonalDetailsById: builder.mutation({
            query: (details) => ({
                url: '/Candidate/UpdateCandidatePersonalDetailsById',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateCandidateProfessionalDetailsById: builder.mutation({
            query: (details) => ({
                url: '/Candidate/UpdateCandidateProfessionalDetailsById',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        downloadFile: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetFile?storagePath=${details.storagePath}&fileName=${details.fileName}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        downloadCandidateFile: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetFile?storagePath=${details.storagePath}&fileName=${details.fileName}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        exportCandidateListReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/ExportCandidateListReport`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getFollowUpCandidate: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetFollowUpCandidate`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllRejectedReason: builder.mutation({
            query: () => ({
                url: encryptQueryString(`/Candidate/GetAllRejectedReason`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getOpenCandidate: builder.query({
            query: () => ({
                url: '/Candidate/GetFollowUpCandidateStatusOpen',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getDashboardCounts: builder.query({
            query: () => ({
                url: encryptQueryString(`/Candidate/CandidateGetDashboardCounts`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getFollowUpCandidateDashboard: builder.query({
            query: () => ({
                url: encryptQueryString(`/Candidate/GetFollowUpCandidateDashboard`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScheduleCandidateDashboard: builder.query({
            query: () => ({
                url: '/Candidate/GetDashboardScheduledCandidate',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getOpenCandidateList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetOpenCandidate`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getCloseCandidateList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetCloseCandidate`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScheduleInterviewList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetScheduleInterviewList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getDeleteCandidateList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetDeleteCandidateList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportCandidates: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/ExportCandidates?StatusType=${details}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getScheduledCandidateListByUserId: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Candidate/GetScheduleInterviewByUserIdList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        importCandidate: builder.mutation({
            query: (details) => ({
                url: '/Candidate/ImportCandidate',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getRecentActivityDashboard: builder.query({
            query: () => ({
                url: '/CandidateInteraction/GetRecentActivityDashboard',
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        uploadResumeCandidate: builder.mutation({
            query: (details) => ({
                url: '/Candidate/AddResumeParsingCandidate',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getNextStatusByProcessStatusId: builder.query({
            query: (processStatusId) => ({
                url: encryptQueryString(`/Status/GetNextStatusByProcessStatusId/?processStatusId=${Number(processStatusId)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllFollowUpReason: builder.mutation({
            query: () => ({
                url: encryptQueryString(`/FollowupReason/GetFollowupReason`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useAddCandidateMutation,
    useImportCandidateMutation,
    useDeleteCandidateMutation,
    useLazyGetCandidateDetailsByIdQuery,
    useLazyGetProcessStatusQuery,
    useLazyGetUserDetailsQuery,
    useUpdateCandidatePersonalDetailsByIdMutation,
    useUpdateCandidateProfessionalDetailsByIdMutation,
    useLazyDownloadFileQuery,
    useLazyDownloadCandidateFileQuery,
    useLazyExportCandidateListReportQuery,
    useLazyExportCandidatesQuery,
    useGetFollowUpCandidateMutation,
    useGetScheduleInterviewListMutation,
    useGetDeleteCandidateListMutation,
    useGetAllRejectedReasonMutation,
    useLazyGetOpenCandidateQuery,
    useLazyGetDashboardCountsQuery,
    useLazyGetFollowUpCandidateDashboardQuery,
    useLazyGetScheduleCandidateDashboardQuery,
    useGetOpenCandidateListMutation,
    useGetCloseCandidateListMutation,
    useGetScheduledCandidateListByUserIdMutation,
    useLazyGetRecentActivityDashboardQuery,
    useUploadResumeCandidateMutation,
    useLazyGetNextStatusByProcessStatusIdQuery,
    useGetAllFollowUpReasonMutation,
} = candidateAPI;

export default candidateAPI;